import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'shared/stores/store';
import 'shared/i18n/config';
import Layout from './components/Layout';
import Routes from './routes';
import './App.css';
import { useSelector } from "react-redux";
import i18n from 'shared/i18n/config';
import { Provider } from 'react-redux';
import { updateMetaTags, updateMetaTagsForRoute } from './lib/metaUtils';

// Component to handle route changes for meta updates
function RouteObserver() {
    const location = useLocation();

    useEffect(() => {
        // Update meta tags when route changes
        updateMetaTagsForRoute(location.pathname);

        // Scroll to top when route changes
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return null;
}

// Component that contains the layout and routes
function AppLayout() {
    return (
        <>
            <RouteObserver />
            <Layout>
                <Routes />
            </Layout>
        </>
    );
}

function AppContent() {
    const { language } = useSelector((state) => state.auth);

    useEffect(() => {
        if (language) {
            i18n.changeLanguage(language);
            // Update meta tags when language changes
            updateMetaTags();
        }
    }, [language]);

    return (
        <Router>
            <AppLayout />
        </Router>
    );
}

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <AppContent />
            </PersistGate>
        </Provider>
    );
}

export default App;